module.exports = __webpack_public_path__ + "static/media/productDetail_empty_folder.53ea39fc.jpg";